/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Corporate } from '../../models/corporate';
import { CorporateCriteria } from '../../models/corporate-criteria';

export interface ApiMasterCorporateGetByCriteriaPost$Params {
      body?: CorporateCriteria
}

export function apiMasterCorporateGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterCorporateGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Corporate>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCorporateGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Corporate>>;
    })
  );
}

apiMasterCorporateGetByCriteriaPost.PATH = '/api/Master/Corporate/GetByCriteria';
